import { render, staticRenderFns } from "./mirror-img.vue?vue&type=template&id=6541f4c2&"
import script from "./mirror-img.vue?vue&type=script&lang=js&"
export * from "./mirror-img.vue?vue&type=script&lang=js&"
import style0 from "./mirror-img.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports